import { publicKeyToPem as pkiPublicKeyToPem } from 'node-forge/pki'
import { formatPem } from './formatPem'
import type { PublicKey } from './re-exports'

export const publicKeyToPem = (publicKey: PublicKey) => formatPem(pkiPublicKeyToPem(publicKey))
